// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-box {
  display: grid;
  grid-template-columns: auto 1fr;
  overflow: hidden;
}
.landing-box .landing-box-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  padding: 0;
}
.landing-box .landing-box-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 15px 20px;
}

.cms-top-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  min-height: 54px;
  margin: 0;
  padding: 8px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e8edf3;
}

.cms-profile-trigger {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  padding: 4px 10px 4px 4px;
  border-radius: 8px;
  cursor: pointer;
  color: #101828;
  background: transparent;
  border: none;
  outline: none;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s ease;
}
.cms-profile-trigger:hover, .cms-profile-trigger:focus-visible {
  background: #f2f4f7;
}

.cms-profile-trigger-chevron {
  margin-left: 2px;
  color: #667085;
  font-size: 11px;
  flex-shrink: 0;
}

.cms-profile-avatar {
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  background: #d0d5dd;
}
.cms-profile-avatar.ant-avatar {
  color: #344054;
  font-size: 13px;
  font-weight: 700;
  line-height: 36px;
}

.cms-profile-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
  max-width: 200px;
}

.cms-profile-summary-name {
  display: block;
  overflow: hidden;
  width: 100%;
  margin: 0;
  color: #101828;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cms-profile-summary-id {
  display: block;
  overflow: hidden;
  width: 100%;
  margin: 0;
  color: #667085;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cms-profile-dropdown .cms-profile-menu.ant-dropdown-menu {
  min-width: 320px;
  margin-top: 8px;
  padding: 0;
  border: 1px solid #e8edf3;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(16, 24, 40, 0.16), 0 4px 16px rgba(16, 24, 40, 0.08);
}
.cms-profile-dropdown .ant-dropdown-menu-item {
  display: flex;
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 1.45 !important;
  clear: both;
  color: #101828 !important;
}
.cms-profile-dropdown .ant-dropdown-menu-item .ant-dropdown-menu-title-content {
  flex: 1 1;
  margin: 0 !important;
}
.cms-profile-dropdown .ant-dropdown-menu-item-disabled {
  align-items: flex-start !important;
  opacity: 1 !important;
  cursor: default !important;
  color: inherit !important;
}
.cms-profile-dropdown .ant-dropdown-menu-item-disabled:hover {
  background: transparent !important;
}
.cms-profile-dropdown .ant-dropdown-menu-item-divider.cms-profile-menu-divider {
  margin: 0 !important;
  border-top-color: #f2f4f7 !important;
}
.cms-profile-dropdown .ant-dropdown-menu-item:not(.cms-profile-logout):not(.ant-dropdown-menu-item-disabled):hover {
  background: #f9fafb !important;
}
.cms-profile-dropdown .cms-profile-logout.ant-dropdown-menu-item {
  color: #d92d20 !important;
}
.cms-profile-dropdown .cms-profile-logout.ant-dropdown-menu-item .cms-profile-menu-action-icon-box {
  background: rgba(217, 45, 32, 0.08);
  border-color: rgba(217, 45, 32, 0.14);
}
.cms-profile-dropdown .cms-profile-logout.ant-dropdown-menu-item .cms-profile-menu-action-icon-box svg,
.cms-profile-dropdown .cms-profile-logout.ant-dropdown-menu-item .cms-profile-menu-action-icon-box .anticon {
  color: #d92d20 !important;
}
.cms-profile-dropdown .cms-profile-logout.ant-dropdown-menu-item:hover {
  background: rgba(217, 45, 32, 0.06) !important;
  color: #b42318 !important;
}
.cms-profile-dropdown .cms-profile-logout.ant-dropdown-menu-item:hover .cms-profile-menu-action-icon-box {
  background: rgba(217, 45, 32, 0.12);
  border-color: rgba(217, 45, 32, 0.22);
}
.cms-profile-dropdown .cms-profile-logout.ant-dropdown-menu-item:hover .cms-profile-menu-action-icon-box svg,
.cms-profile-dropdown .cms-profile-logout.ant-dropdown-menu-item:hover .cms-profile-menu-action-icon-box .anticon {
  color: #b42318 !important;
}

.cms-profile-menu-header.ant-dropdown-menu-item {
  padding: 20px 20px 18px !important;
  background: #fbfcfe !important;
  border-bottom: 1px solid #eef2f7;
}

.cms-profile-menu-header-inner {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
}

.cms-profile-menu-header-avatar {
  flex: 0 0 auto;
  width: 48px !important;
  height: 48px !important;
  line-height: 48px !important;
  background: linear-gradient(135deg, #075dc5 0%, #004195 100%);
  border: 1px solid rgba(7, 93, 197, 0.2);
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(7, 93, 197, 0.2);
}
.cms-profile-menu-header-avatar.ant-avatar {
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
}

.cms-profile-menu-header-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1 1 auto;
}

.cms-profile-menu-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.cms-profile-menu-name {
  display: block;
  margin: 0;
  color: #101828;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.005em;
}

.cms-profile-menu-id {
  margin: 0;
  color: #667085;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
}

.cms-profile-menu-role {
  margin: 0;
  width: fit-content;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  color: #344054;
  background: #ffffff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  letter-spacing: 0.01em;
}

.cms-profile-menu-email {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  color: #667085;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  word-break: break-word;
}

.cms-profile-menu-email-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  background: #eff6ff;
  border: 1px solid rgba(7, 93, 197, 0.12);
  border-radius: 8px;
}

.cms-profile-menu-email-icon {
  font-size: 16px;
  color: #075dc5;
  line-height: 1;
}

.cms-profile-menu-email-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  color: #475467;
}

.cms-profile-menu-action.ant-dropdown-menu-item {
  padding: 12px 20px !important;
}

.cms-profile-menu-action-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
}

.cms-profile-menu-action-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  background: #eff6ff;
  border: 1px solid rgba(7, 93, 197, 0.12);
  border-radius: 8px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.cms-profile-menu-action-icon {
  font-size: 16px;
  color: #075dc5;
  line-height: 1;
}

.cms-profile-menu-action-text {
  flex: 1 1 auto;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.005em;
}`, "",{"version":3,"sources":["webpack://./src/pages/Landing/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AACJ;AAEE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iCAAA;AADF;AAGE;EAEE,mBAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAHF;AAKE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAJF;;AAQE;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFACE;AANN;AAUE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;EACA,yBAAA;AARJ;AAUI;EACE,SAAA;EACA,oBAAA;AARN;AAYE;EACE,kCAAA;EACA,qBAAA;EACA,0BAAA;EACA,yBAAA;AAVJ;AAYI;EACE,kCAAA;AAVN;AAcE;EACE,oBAAA;EACA,oCAAA;AAZJ;AAeE;EACE,8BAAA;AAbJ;AAgBE;EACE,yBAAA;AAdJ;AAgBI;EACE,mCAAA;EACA,qCAAA;AAdN;AAgBM;;EAEE,yBAAA;AAdR;AAkBI;EACE,8CAAA;EACA,yBAAA;AAhBN;AAkBM;EACE,mCAAA;EACA,qCAAA;AAhBR;AAkBQ;;EAEE,yBAAA;AAhBV;;AAuBA;EACE,kCAAA;EACA,8BAAA;EACA,gCAAA;AApBF;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,6DAAA;EACA,uCAAA;EACA,8BAAA;EACA,2CAAA;AApBF;AAsBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AApBJ;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AArBF;;AAwBA;EACE,cAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AArBF;;AAwBA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AArBF;;AAwBA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AArBF;;AAwBA;EACE,6BAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gEAAA;AArBF;;AAwBA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AArBF;;AAwBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AArBF","sourcesContent":[".landing-box {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  overflow: hidden;\n\n  .landing-box-content {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    min-height: 0;\n    min-width: 0;\n    overflow: hidden;\n    padding: 0;\n  }\n\n  .landing-box-scroll {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 20px 15px 20px;\n  }\n}\n\n.cms-top-header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-shrink: 0;\n  min-height: 54px;\n  margin: 0;\n  padding: 8px 20px;\n  background: #ffffff;\n  border-bottom: 1px solid #e8edf3;\n}\n\n.cms-profile-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  padding: 4px 10px 4px 4px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #101828;\n  background: transparent;\n  border: none;\n  outline: none;\n  user-select: none;\n  transition: background 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    background: #f2f4f7;\n  }\n}\n\n.cms-profile-trigger-chevron {\n  margin-left: 2px;\n  color: #667085;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.cms-profile-avatar {\n  flex: 0 0 36px;\n  width: 36px;\n  height: 36px;\n  background: #d0d5dd;\n\n  &.ant-avatar {\n    color: #344054;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 36px;\n  }\n}\n\n.cms-profile-summary {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  min-width: 0;\n  max-width: 200px;\n}\n\n.cms-profile-summary-name {\n  display: block;\n  overflow: hidden;\n  width: 100%;\n  margin: 0;\n  color: #101828;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cms-profile-summary-id {\n  display: block;\n  overflow: hidden;\n  width: 100%;\n  margin: 0;\n  color: #667085;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cms-profile-dropdown {\n  .cms-profile-menu.ant-dropdown-menu {\n    min-width: 320px;\n    margin-top: 8px;\n    padding: 0;\n    border: 1px solid #e8edf3;\n    border-radius: 12px;\n    background: #ffffff;\n    overflow: hidden;\n    box-shadow:\n      0 16px 48px rgba(16, 24, 40, 0.16),\n      0 4px 16px rgba(16, 24, 40, 0.08);\n  }\n\n  .ant-dropdown-menu-item {\n    display: flex;\n    align-items: center;\n    padding: 0 !important;\n    margin: 0 !important;\n    font-size: 15px !important;\n    font-weight: 500 !important;\n    line-height: 1.45 !important;\n    clear: both;\n    color: #101828 !important;\n\n    .ant-dropdown-menu-title-content {\n      flex: 1;\n      margin: 0 !important;\n    }\n  }\n\n  .ant-dropdown-menu-item-disabled {\n    align-items: flex-start !important;\n    opacity: 1 !important;\n    cursor: default !important;\n    color: inherit !important;\n\n    &:hover {\n      background: transparent !important;\n    }\n  }\n\n  .ant-dropdown-menu-item-divider.cms-profile-menu-divider {\n    margin: 0 !important;\n    border-top-color: #f2f4f7 !important;\n  }\n\n  .ant-dropdown-menu-item:not(.cms-profile-logout):not(.ant-dropdown-menu-item-disabled):hover {\n    background: #f9fafb !important;\n  }\n\n  .cms-profile-logout.ant-dropdown-menu-item {\n    color: #d92d20 !important;\n\n    .cms-profile-menu-action-icon-box {\n      background: rgba(217, 45, 32, 0.08);\n      border-color: rgba(217, 45, 32, 0.14);\n\n      svg,\n      .anticon {\n        color: #d92d20 !important;\n      }\n    }\n\n    &:hover {\n      background: rgba(217, 45, 32, 0.06) !important;\n      color: #b42318 !important;\n\n      .cms-profile-menu-action-icon-box {\n        background: rgba(217, 45, 32, 0.12);\n        border-color: rgba(217, 45, 32, 0.22);\n\n        svg,\n        .anticon {\n          color: #b42318 !important;\n        }\n      }\n    }\n  }\n}\n\n.cms-profile-menu-header.ant-dropdown-menu-item {\n  padding: 20px 20px 18px !important;\n  background: #fbfcfe !important;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.cms-profile-menu-header-inner {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.cms-profile-menu-header-avatar {\n  flex: 0 0 auto;\n  width: 48px !important;\n  height: 48px !important;\n  line-height: 48px !important;\n  background: linear-gradient(135deg, #075dc5 0%, #004195 100%);\n  border: 1px solid rgba(7, 93, 197, 0.2);\n  border-radius: 12px !important;\n  box-shadow: 0 2px 8px rgba(7, 93, 197, 0.2);\n\n  &.ant-avatar {\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 700;\n  }\n}\n\n.cms-profile-menu-header-text {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.cms-profile-menu-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cms-profile-menu-name {\n  display: block;\n  margin: 0;\n  color: #101828;\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 1.35;\n  letter-spacing: 0.005em;\n}\n\n.cms-profile-menu-id {\n  margin: 0;\n  color: #667085;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.cms-profile-menu-role {\n  margin: 0;\n  width: fit-content;\n  max-width: 100%;\n  padding: 4px 10px;\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  color: #344054;\n  background: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.35;\n  letter-spacing: 0.01em;\n}\n\n.cms-profile-menu-email {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: #ffffff;\n  border: 1px solid #e8edf3;\n  border-radius: 10px;\n  color: #667085;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.cms-profile-menu-email-icon-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  background: #eff6ff;\n  border: 1px solid rgba(7, 93, 197, 0.12);\n  border-radius: 8px;\n}\n\n.cms-profile-menu-email-icon {\n  font-size: 16px;\n  color: #075dc5;\n  line-height: 1;\n}\n\n.cms-profile-menu-email-text {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n  color: #475467;\n}\n\n.cms-profile-menu-action.ant-dropdown-menu-item {\n  padding: 12px 20px !important;\n}\n\n.cms-profile-menu-action-row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  width: 100%;\n}\n\n.cms-profile-menu-action-icon-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  background: #eff6ff;\n  border: 1px solid rgba(7, 93, 197, 0.12);\n  border-radius: 8px;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.cms-profile-menu-action-icon {\n  font-size: 16px;\n  color: #075dc5;\n  line-height: 1;\n}\n\n.cms-profile-menu-action-text {\n  flex: 1 1 auto;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.005em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
